import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, MapPinIcon, XIcon } from 'lucide-react';
import { purchases, type PurchaseNotice } from '../data/purchases';
interface PurchasePopupProps {
  /** Tiempo visible de cada aviso, en segundos */
  visibleSeconds?: number;
}
const randomDelay = (): number => 40000 + Math.random() * 20000;
const randomMinutes = (): number => 2 + Math.floor(Math.random() * 12);
export function PurchasePopup({
  visibleSeconds = 6
}: PurchasePopupProps) {
  const [notice, setNotice] = useState<PurchaseNotice | null>(null);
  const [minutes, setMinutes] = useState<number>(4);
  const [dismissed, setDismissed] = useState(false);
  const index = useRef(0);
  const timers = useRef<number[]>([]);
  useEffect(() => {
    if (dismissed) return;
    const clearTimers = () => {
      timers.current.forEach(id => window.clearTimeout(id));
      timers.current = [];
    };
    const show = () => {
      const next = purchases[index.current % purchases.length];
      index.current += 1;
      setMinutes(randomMinutes());
      setNotice(next);
      timers.current.push(window.setTimeout(() => {
        setNotice(null);
        timers.current.push(window.setTimeout(show, randomDelay()));
      }, visibleSeconds * 1000));
    };
    timers.current.push(window.setTimeout(show, 12000));
    return clearTimers;
  }, [dismissed, visibleSeconds]);
  return <AnimatePresence data-id="element-230" data-mp="n97ptk7xyabf">
      {notice && !dismissed ? <motion.aside key={`${notice.name}-${index.current}`} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 12,
      scale: 0.98
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} aria-live="polite" className="fixed bottom-[4.75rem] left-3 right-3 z-40 max-w-[22rem] rounded-xl bg-cream-50 p-3 shadow-lift ring-1 ring-forest-900/10 sm:left-5 sm:right-auto sm:w-[22rem] md:bottom-5" data-id="element-231" data-mp="i93fyd1jgdu6">
          <div className="flex items-start gap-2.5" data-id="element-232" data-mp="2aobbwi679qtv">
            <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-forest-800" data-id="element-233" data-mp="2fmv3oz7h5wu5">
              <BadgeCheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-234" data-mp="2ko2aow1smrzr" />
            </span>

            <div className="min-w-0 flex-1" data-id="element-235" data-mp="2pkizztkqbcef">
              <p className="flex items-center gap-1.5 text-[0.58rem] font-bold uppercase tracking-[0.12em] text-forest-600" data-id="element-236" data-mp="1ry3hcogkg8pa">
                Compra verificada
                <span className="h-1.5 w-1.5 rounded-full bg-forest-500" aria-hidden="true" data-id="element-237" data-mp="1wxoequg388zw" />
              </p>
              <p className="mt-0.5 text-[0.82rem] font-semibold leading-snug text-forest-900" data-id="element-238" data-mp="21uyf3550m52i">
                {notice.name} compró el {notice.pack}
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-[0.7rem] text-forest-900/55" data-id="element-239" data-mp="196j20o5g1wtt">
                <MapPinIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-240" data-mp="1e5vq1c81x9xz" />
                <span className="truncate" data-id="element-241" data-mp="3rgora192qhck">{notice.city}</span>
                <span aria-hidden="true" data-id="element-242" data-mp="3reudd6w7zphz">·</span>
                <span className="shrink-0" data-id="element-243" data-mp="3nf3f6i4d673f">hace {minutes} min</span>
              </p>
            </div>

            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar avisos de compra" className="-mr-1 -mt-1 rounded-md p-1 text-forest-900/35 transition-colors duration-150 ease-out hover:text-forest-900" data-id="element-244" data-mp="3ifh1y8ojcqum">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-245" data-mp="33r42h1q8opvd" />
            </button>
          </div>
        </motion.aside> : null}
    </AnimatePresence>;
}